/* eslint-disable @typescript-eslint/no-empty-interface, @typescript-eslint/no-misused-promises,
class-methods-use-this */
import React, { Component } from 'react';
import { confirmWrapper } from 'src/components/Dialog';
import { AxiosResponse } from 'axios';
import withRouter from '../../hooks/withRouter';

import {
  AddATSPropType,
  Location,
  LocationFormSubmitHandler,
  LocationResponse,
  LocationsProps,
  LocationsState,
  LocationsViewRendererProps,
  UpdateATSPropType,
} from './types';
import API from '../../network';
import ViewRenderer from './views';
import { AddLocation } from './components';

class Locations extends Component
  <LocationsProps, LocationsState> {
  constructor(props: LocationsProps) {
    super(props);

    this.state = {
      locations: [],
      filterLocations: [],
      locationsFetching: true,
    };
  }

  componentDidMount() {
    this.getAllLocations();
  }

  getAllLocations = () => {
    this.setState(
      {
        locationsFetching: true,
        locations: [],
        filterLocations: [],
      },
      async () => {
        try {
          const response: AxiosResponse<LocationResponse[]> = await
          API.getInstance().fetchLocations();
          const eventsData: LocationResponse[] = response.data;
          this.setState({
            locations: eventsData,
            filterLocations: eventsData,
          });
        } catch (e) {
          await confirmWrapper('Something went wrong', {
            hideSecondaryBtn: true,
            variant: 'danger',
          });
        } finally {
          this.setState({
            locationsFetching: false,
          });
        }
      },
    );
  };

  onDeleteRow = async (data: Location) => {
    const { value, id = 0 } = data;
    const deleteConfirmed = await confirmWrapper(`Are you sure want to delete ${value}?`, {
      variant: 'danger',
    });
    if (deleteConfirmed) {
      try {
        await API.getInstance().deleteATSProperties(id, 'LOCATION');
        await confirmWrapper('Location deleted successfully!', {
          hideSecondaryBtn: true,
          variant: 'success',
          autoClose: true,
        });
        this.getAllLocations();
      } catch (e) {
        await confirmWrapper('Something went wrong', {
          hideSecondaryBtn: true,
          variant: 'danger',
        });
      } finally {
        this.setState({
          locationsFetching: false,
        });
      }
    }
  };

  createLocation = async (data: LocationFormSubmitHandler): Promise<void> => {
    const { values } = data;
    try {
      const request: AddATSPropType = {
        type: 'LOCATION',
        value: values?.value,
      };
      await API.getInstance().addATSProperty(request);
      this.getAllLocations();
    } catch (e: any) {
      await confirmWrapper(e?.response?.data.message || 'Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
      throw e;
    }
  };

  updateLocation = async (data: LocationFormSubmitHandler): Promise<void> => {
    const { values } = data;
    const { value, id } = values;
    const request: UpdateATSPropType = {
      id,
      type: 'LOCATION',
      value,
    };
    try {
      await API.getInstance().updateATSProperty(request);
      this.getAllLocations();
    } catch (e: any) {
      await confirmWrapper(e?.response?.data.message || 'Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
      throw e;
    }
  };

  showCreateLocation = async () => {
    await confirmWrapper('', {
      variant: '',
      hidePrimaryBtn: true,
      hideSecondaryBtn: true,
      maxWidth: 'dialogSmall',
      fullWidth: true,
      containerClasses: 'p-0',
      showCloseButton: true,
      disableBackdropClickClose: true,
      disableEscapeKeyDownClose: true,
      dialogContent: <AddLocation
        disabled
        readOnly
        onCreateLocation={this.createLocation}
      />,
    });
  };

  onEditRow = async (data: Location) => {
    await confirmWrapper('', {
      variant: '',
      hidePrimaryBtn: true,
      hideSecondaryBtn: true,
      maxWidth: 'dialogSmall',
      fullWidth: true,
      showCloseButton: true,
      containerClasses: 'p-0',
      disableBackdropClickClose: true,
      disableEscapeKeyDownClose: true,
      dialogContent: <AddLocation
        defaultValues={data}
        disabled
        readOnly
        onCreateLocation={this.updateLocation}
      />,
    });
  };

  onChange = (searchString: string) => {
    const { locations } = this.state;
    const filteredObjects = locations.filter(({ value }) => value && value.toLowerCase()
      .includes(searchString.toLowerCase()));
    this.setState({
      filterLocations: filteredObjects,
    });
  };

  getProps = (): LocationsViewRendererProps => {
    const {
      locations,
      locationsFetching,
      filterLocations,
    } = this.state;

    return {
      locations,
      filterLocations,
      locationsFetching,
      showCreateLocation: this.showCreateLocation,
      onDeleteRow: this.onDeleteRow,
      onEditRow: this.onEditRow,
      onChange: this.onChange,
    };
  };

  render() {
    const viewProps: LocationsViewRendererProps = this.getProps();

    return (
      <ViewRenderer {...viewProps} />
    );
  }
}

export default withRouter(Locations);
